import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/zarviya_symbol.png';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#fefaf5] text-[#2d161e] px-6 pt-10 pb-20">
      {/* Logo and Background */}
      <div className="flex justify-center mb-2">
        <div
          className="relative w-16 h-16 b rounded-full flex items-center justify-center shadow-md "
          style={{
            background: `radial-gradient(circle at 30% 30%, #4c0f2e, #2a081a, #4c0f2e)`,
            backdropFilter: 'blur(10px)',
            boxShadow: 'inset 0 2px 8px rgba(255,255,255,0.1), inset 0 -2px 8px rgba(0,0,0,0.3)',
          }}
        >
          <img src={logo} alt="Zarviya Logo" className="w-12 h-12 object-contain -mt-4" />
        </div>
      </div>

      <div className="text-center mb-8">
        <h2 className="text-2xl font-cinzelDecorative tracking-wider">Zarviya</h2>
        <p className="text-sm leading-relaxed text-[#4c0f2e] max-w-sm mx-auto mt-2">
          Rooted in tradition, elevated with elegance. Explore timeless jewellery curated for every
          story.
        </p>
      </div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Navigation */}
        <div>
          <h3 className="text-lg font-semibold mb-3 uppercase tracking-wider text-[#4c0f2e]">
            Navigate
          </h3>
          <ul className="space-y-2 text-sm">
            <li className="cursor-pointer hover:text-[#4c0f2e]/80" onClick={() => navigate('/')}>
              Home
            </li>
            <li
              className="cursor-pointer hover:text-[#4c0f2e]/80"
              onClick={() => navigate('/about')}
            >
              About Us
            </li>
            <li className="cursor-pointer hover:text-[#4c0f2e]/80" onClick={() => navigate('/faq')}>
              FAQs
            </li>
            <li
              className="cursor-pointer hover:text-[#4c0f2e]/80"
              onClick={() => navigate('/policy#refund')}
            >
              Returns
            </li>
            <li
              className="cursor-pointer hover:text-[#4c0f2e]/80"
              onClick={() => navigate('/policy#privacy')}
            >
              Privacy Policy
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-semibold mb-3 uppercase tracking-wider text-[#4c0f2e]">
            Support
          </h3>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="tel:+918848899198" className="hover:text-[#4c0f2e]/80">
                Call: +91 8848899198
              </a>
            </li>
            <li>
              <a href="mailto:contact@zarviya.com" className="hover:text-[#4c0f2e]/80">
                Email: contact@zarviya.com
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/918848899198"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#4c0f2e]/80"
              >
                Chat on WhatsApp
              </a>
            </li>
            <li className="text-xs text-[#a39288]">Mon–Sat, 10:00 AM to 7:30 PM IST</li>
          </ul>
        </div>
      </div>

      <div className="mt-12 text-center text-xs text-[#a39288] border-t border-[#e0c3b5] pt-6">
        &copy; {new Date().getFullYear()} Zarviya. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
